import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { Body, BodySemibold } from "storybook-components/Typography";

const NavLinkWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  position: sticky;
  min-width: 140px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

const StyledTitle = styled(BodySemibold)`
  margin: 16px 0;
  color: ${({ theme }) => theme.colors.green5};
`;

const StyleLinkText = styled(Body)`
  margin: 16px 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.green5};
  &:hover,
  &.active {
    text-decoration: underline;
  }
`;

export default () => (
  <NavLinkWrapper>
    <StyledTitle>Categories</StyledTitle>
    <StyledLink to="/category/analysis/" activeClassName="active">
      <StyleLinkText>Analysis</StyleLinkText>
    </StyledLink>
    <StyledLink to="/category/general/" activeClassName="active">
      <StyleLinkText>Mode updates</StyleLinkText>
    </StyledLink>
    <StyledLink to="/category/visualization/" activeClassName="active">
      <StyleLinkText>Visualization</StyleLinkText>
    </StyledLink>
    <StyledLink to="/category/data-teams/" activeClassName="active">
      <StyleLinkText>Data teams</StyleLinkText>
    </StyledLink>
    <StyledLink to="/all/" activeClassName="active">
      <StyleLinkText>All articles</StyleLinkText>
    </StyledLink>
  </NavLinkWrapper>
);
